import styled from "styled-components";

export const Hr = styled.hr`
  border: none;
  height: 1px;
  background: #F0F0F0;
`;
